import builder from '@builder.io/react';
import { BUILDER_API_KEY } from './environment';
import { checkIfCustomer } from './helpers';
import { ShippingCountryState } from './shipping';

export const getSharedUserTargetingAttributes = () => {
  const isLoggedIn = checkIfCustomer();
  const countryCode = ShippingCountryState.countryCode ?? 'US';
  // ? [REVISIT] we want to this to be "isApp" instead; otherwise we explode the cachekey
  // const userAgent = navigator.userAgent.toLowerCase().includes('aloios') ? 'aloios' : navigator.userAgent;

  return {
    isLoggedIn,
    countryCode,
  };
};

// ? [REVISIT] type this
export const fetchDataFromBuilder = async <T extends unknown>(
  modelname: string,
  { additionalUserAttributes }: { additionalUserAttributes?: Record<string, unknown> } = {}
) => {
  const data: BuilderResponse<T> = await builder.get(modelname, {
    apiKey: BUILDER_API_KEY,

    userAttributes: {
      ...getSharedUserTargetingAttributes(),
      ...additionalUserAttributes,
    },
  });

  return data;
};

// Builder Types
export type BuilderResponse<T> = {
  createdBy: string;
  createdDate: number;
  data: T;
  folders: unknown[];
  id: string;
  lastUpdatedBy: string;
  meta: Meta;
  modelId: string;
  name: string;
  published: string;
  query: unknown[];
  testRatio: number;
  variations: Variations;
  lastUpdated: number;
  firstPublished: number;
  rev: string;
  variationId: string;
};

export type Meta = {
  format: string;
  kind: string;
  lastPreviewUrl: string;
  shopifyCustomDomain: string;
  shopifyDomain: string;
};

export type Variations = {};
